import { render, staticRenderFns } from "./CourseEffectButtons.vue?vue&type=template&id=760eb145&"
import script from "./CourseEffectButtons.vue?vue&type=script&lang=js&"
export * from "./CourseEffectButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports